import React, { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import { useAccount } from "wagmi";

// Layouts
import AuthLayout from "layouts/auth";
import AdminLayout from "layouts/admin";
import RtlLayout from "layouts/rtl";

// Centralized widget wrapper for all widget routes
import WidgetWrapper from "components/widget/RangoWidget";

import TermsOfService from "components/footer/TOS"; // Adjust the path as needed


const App = () => {
  const location = useLocation();
  const { address, isConnected } = useAccount();

  useEffect(() => {
    if (isConnected && address) {
      import("mixpanel-browser")
        .then(({ default: mixpanel }) => {
          mixpanel.init("d1c6071c36d4637fea866b97d1295dcd", {
            debug: true,
            track_pageview: false,
            persistence: "localStorage",
          });
          mixpanel.identify(address);
          mixpanel.people.set({ "$email": address });
        })
        .catch((error) => console.error("Error loading Mixpanel:", error));
    }
  }, [isConnected, address]);

  useEffect(() => {
    const basename = "/dashboard";
    let pagePath = location.pathname + location.search;
    if (pagePath.startsWith(basename)) {
      pagePath = pagePath.slice(basename.length);
    }
    if (!pagePath.startsWith("/")) {
      pagePath = "/" + pagePath;
    }
    if (process.env.NODE_ENV === "production") {
      ReactGA.send({ hitType: "pageview", page: pagePath });
      console.log(`GA Pageview sent: ${pagePath}`);
    }
  }, [location]);

  return (
    <Routes>
      <Route path="/swap/*" element={<WidgetWrapper />} />

      {/* Other application routes */}
      <Route path="auth/*" element={<AuthLayout />} />
      <Route path="admin/*" element={<AdminLayout />} />
      <Route path="rtl/*" element={<RtlLayout />} />
      <Route path="/" element={<Navigate to="/admin" replace />} />
      <Route path="/tos" element={<TermsOfService />} />

    </Routes>
  );
};

export default App;
